<template>
  <v-card width="100%" tile flat class="text-center">
    <v-card-text class="pa-0">
      <v-row justify="center" class="ma-0 pa-0">
        <v-col cols="12" sm="12" md="12" lg="10" xl="10">
          <v-row justify="center" align="center" class="ma-0 pa-0">
            <v-col cols="12" class="pa-0">
              <v-row align="center" justify="space-between" class="pa-0 ma-0">
                <v-col
                  v-for="(shopItemG,gri) in grTab"
                  :key="gri"
                  class="px-0"
                  cols="6"
                  sm="4"
                  md="3"
                  lg="3"
                  xl="3"
                >
                  <v-btn
                    block
                    small
                    text
                    @click="selectFilter(gri)"
                    light
                    class="btn-grp-sel topmnu-btn-blk"
                    :class="{ active: selectF === gri }"
                  >{{shopItemG.title}}</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- Section SUBCATEGORY -->
          <v-card flat v-if="selectF === 1">
            <v-row align="center" justify="start" class="px-2" light>
              <v-col
                cols="12"
                sm="4"
                md="4"
                lg="4"
                :key="`gri-`+gri"
                v-for="(gritem,gri)  in categories[0].category"
                class="pa-1"
              >
                <v-btn
                  block
                  small
                  light
                  @click="selectCategory(gri)"
                  :class="[selectGrpId === gri ? activeClass : noActiveClass, '']"
                  class="btn-grp-sel topmnu-btn"
                >{{gritem.namesubcat}}</v-btn>
              </v-col>
            </v-row>
          </v-card>
          <!-- Section SUBCATEGORY -->
          <!-- Section AB -->
          <v-card flat v-if="selectF === 2">
            <v-row align="center" justify="center" class="px-0" light>
              <v-col cols="12">
                <span
                  :key="`grie-`+grie"
                  v-for="(azItem,grie)  in alphabetArrEng"
                  class="px-0 py-1"
                >
                  <v-btn
                    small
                    light
                    @click="selectAZ(azItem.letter.toUpperCase())"
                    :disabled="!alphabetArr.includes(azItem.letter.toUpperCase())"
                    :class="[selectAB === azItem.letter.toUpperCase() ? activeClass : noActiveClass, '']"
                    class="btn-grp-sel ab-btn topmnu-btn ma-1"
                  >{{azItem.letter}}</v-btn>
                </span>
              </v-col>
            </v-row>
            <v-row align="center" justify="center" class="px-0" light>
              <v-col cols="12">
                <span
                  :key="`grie-`+grie"
                  v-for="(azItem,grie)  in alphabetArrRus"
                  class="px-0 py-1"
                >
                  <v-btn
                    small
                    light
                    @click="selectAZ(azItem.letter.toUpperCase())"
                    :disabled="!alphabetArr.includes(azItem.letter.toUpperCase())"
                    :class="[selectAB === azItem.letter.toUpperCase() ? activeClass : noActiveClass, '']"
                    class="btn-grp-sel ab-btn topmnu-btn ma-1"
                  >{{azItem.letter}}</v-btn>
                </span>
              </v-col>
            </v-row>
            <v-row align="center" justify="center" class="px-2" light>
              <v-col cols="12">
                <span :key="`grie-`+grie" v-for="(azItem,grie)  in alphabetNum" class="px-0 py-1">
                  <v-btn
                    small
                    light
                    @click="selectAZ(azItem)"
                    :class="[selectAB === azItem ? activeClass : noActiveClass, '']"
                    class="btn-grp-sel ab-btn topmnu-btn ma-1"
                  >{{azItem.letter}}</v-btn>
                </span>
              </v-col>
            </v-row>
          </v-card>
          <!-- Section AB -->
          <v-row class="mx-0 mt-4" v-if="filterShops === null">
            <v-col cols="2" :key="sceli" v-for="sceli in 12">
              <v-skeleton-loader
                loading
                :types="{'imagegal':'image,image,image'}"
                type="imagegal"
                class="sceleton-img"
              ></v-skeleton-loader>
            </v-col>
          </v-row>

          <v-row align="center" justify="center" class="mt-4" v-if="filterShops !== null">
            <v-col
              v-for="(shopItem,ins) in filterShops"
              :key="ins"
              class
              cols="4"
              sm="4"
              md="3"
              lg="3"
              xl="2"
            >
              <v-lazy
                v-model="isActiveLazy"
                :options="{
                        threshold: .5
                      }"
                transition="fade-transition"
              >
                <v-hover v-slot:default="{ hover }" open-delay="100">
                  <v-card
                    tile
                    class="text-center"
                    :elevation="hover ? 16 : 2"
                    @click="slectShopFromAll(shopItem)"
                  >
                    <v-row align="start" justify="center" class="ma-0 pa-0">
                      <v-img
                        :src="`http://api.trcgagarinsky.ru/terminal__tmp/`+ shopItem.logourl"
                        aspect-ratio="2.0"
                        class="white ma-2"
                        contain
                      >
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="grey darken-1"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-row>

                    <v-row align="end" justify="center" class="fill-height ma-0">
                      <v-col class="pa-0">
                        <div class="mx-1 name-shop-img pb-1">{{ shopItem.nameK }}</div>
                      </v-col>
                    </v-row>
                    <v-row align="end" justify="center" class="fill-height ma-0">
                      <!-- <v-col class="pa-0 d-flex flex-row-reverse" > -->
                      <v-col class="pa-0">
                        <div class="mx-1 pb-1" v-if=" shopItem.actions.length>0">
                          <v-icon color="pink">mdi-sale</v-icon>
                        </div>
                        <div class="mx-1 empty-sale pb-1" v-else></div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-hover>
              </v-lazy>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <SeoBlock
      :seotxt1="allPages.seo_text_1"
      :seotxt2="allPages.seo_text_2"
      :seogallery="allPages.seo_images"
    />
  </v-card>
</template>
<script>
import Vue from "vue";
import Vuex from "vuex";
import router from "vue-router";
import axios from "axios";
import VueMeta from "vue-meta";
import SeoBlock from "@/components/SeoBlock";

Vue.use(VueMeta);

Vue.use(Vuex);

export default {
  name: "AllShops",
  components: {
    SeoBlock,
  },
  data() {
    return {
      activeClass: "grey lighten-2",
      noActiveClass: "v-btn--depressed  ",
      disableClass: "disabled",
      isActiveLazy: false,
      isShopsLoad: false,
      fixed: false,
      tabsmod: "all",
      filterShops: null,
      selectGrpId: 0,
      selectF: 0,
      selectAB: 0,
      grTab: [
        {
          title: "Все магазины",
        },
        {
          title: "По категориям",
        },
        {
          title: "По алфавиту",
        },
        {
          title: "% - Акции и скидки",
        },
      ],
      shopsAZ: null,
      alphabetArr: [],
      alphabetArrEng: [
        {
          letter: "a",
          activeBtn: true,
        },
        {
          letter: "b",
          activeBtn: false,
        },
        {
          letter: "c",
          activeBtn: false,
        },
        {
          letter: "d",
          activeBtn: false,
        },
        {
          letter: "e",
          activeBtn: false,
        },
        {
          letter: "f",
          activeBtn: false,
        },
        {
          letter: "g",
          activeBtn: false,
        },
        {
          letter: "h",
          activeBtn: false,
        },
        {
          letter: "i",
          activeBtn: false,
        },
        {
          letter: "j",
          activeBtn: false,
        },
        {
          letter: "k",
          activeBtn: false,
        },
        {
          letter: "l",
          activeBtn: false,
        },
        {
          letter: "m",
          activeBtn: false,
        },
        {
          letter: "n",
          activeBtn: false,
        },
        {
          letter: "o",
          activeBtn: false,
        },
        {
          letter: "p",
          activeBtn: false,
        },
        {
          letter: "q",
          activeBtn: false,
        },
        {
          letter: "r",
          activeBtn: false,
        },
        {
          letter: "s",
          activeBtn: false,
        },
        {
          letter: "t",
          activeBtn: false,
        },
        {
          letter: "u",
          activeBtn: false,
        },
        {
          letter: "v",
          activeBtn: false,
        },
        {
          letter: "w",
          activeBtn: false,
        },
        {
          letter: "x",
          activeBtn: false,
        },
        {
          letter: "y",
          activeBtn: false,
        },
        {
          letter: "z",
          activeBtn: false,
        },
      ],
      alphabetArrRus: [
        {
          letter: "а",
          activeBtn: false,
        },
        {
          letter: "б",
          activeBtn: false,
        },
        {
          letter: "в",
          activeBtn: false,
        },
        {
          letter: "г",
          activeBtn: false,
        },
        {
          letter: "д",
          activeBtn: false,
        },
        {
          letter: "е",
          activeBtn: false,
        },
        {
          letter: "ж",
          activeBtn: false,
        },
        {
          letter: "з",
          activeBtn: false,
        },
        {
          letter: "и",
          activeBtn: false,
        },
        {
          letter: "й",
          activeBtn: false,
        },
        {
          letter: "к",
          activeBtn: false,
        },
        {
          letter: "л",
          activeBtn: false,
        },
        {
          letter: "м",
          activeBtn: false,
        },
        {
          letter: "н",
          activeBtn: false,
        },
        {
          letter: "о",
          activeBtn: false,
        },
        {
          letter: "п",
          activeBtn: false,
        },
        {
          letter: "р",
          activeBtn: false,
        },
        {
          letter: "с",
          activeBtn: false,
        },
        {
          letter: "т",
          activeBtn: false,
        },
        {
          letter: "у",
          activeBtn: false,
        },
        {
          letter: "ф",
          activeBtn: false,
        },
        {
          letter: "х",
          activeBtn: false,
        },
        {
          letter: "ц",
          activeBtn: false,
        },
        {
          letter: "ч",
          activeBtn: false,
        },
        {
          letter: "ш",
          activeBtn: false,
        },
        {
          letter: "щ",
          activeBtn: false,
        },
        {
          letter: "ъ",
          activeBtn: false,
        },
        {
          letter: "ы",
          activeBtn: false,
        },
        {
          letter: "ь",
          activeBtn: false,
        },
        {
          letter: "э",
          activeBtn: false,
        },
        {
          letter: "ю",
          activeBtn: false,
        },
        {
          letter: "я",
          activeBtn: false,
        },
      ],
      alphabetNum: [
        {
          letter: "0-9",
          activeBtn: false,
        },
      ],
      selectAZShops: null,
    };
  },

  metaInfo: {
    title: "Магазины -",
  },

  computed: {
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
      isMobile: {
      get () {
        return this.$store.state.app.isMobile
      }
      
    },    
    abArr() {
      let e = "abcdefghijklmnopqrstuvwxyz".toUpperCase().split("");
      let r = "абвгдежзийклмнопрстуфхцчшщъыьэюя".toUpperCase().split("");
      let d = ["9-0"];
      let arrLetters = [];
      arrLetters.push(e);
      arrLetters.push(r);
      arrLetters.push(d);

      if(DEBUG) console.log("arrLetters :", arrLetters);
      return arrLetters;
    },
    loadPathData: {
      get() {
        return this.$store.getters.getLoadPathData;
      },
    },
    shops: {
      get() {
        let allShops = this.$store.state.shops.shops;
        let filterOnly = allShops.filter((allI) => {
          //  if(DEBUG) console.log('allI.category :>> ', allI.category);
          //  if(DEBUG) console.log('allI.NameK :>> ', allI.nameK);
          return (
            !allI.category.includes("50") &&
            !allI.category.includes("43") &&
            !allI.category.includes("37") &&
            !allI.category.includes("42") &&
            !allI.category.includes("56") &&
            !allI.category.includes("38") &&
            !allI.category.includes("46") &&
            !allI.category.includes("39") &&
            !allI.category.includes("41") &&
            !allI.category.includes("40") &&
            !allI.category.includes("48") &&
            !allI.category.includes("47") &&
            !allI.category.includes("49") &&
            !allI.category.includes("16")
          );
        });
        if(DEBUG) console.log("filterOnly :", filterOnly);

        filterOnly = this.sortArray(filterOnly, "nameK");
        return filterOnly;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("loadShops", val);
      },
    },
    categories: {
      get() {
        //  if(DEBUG) console.log('this.$store.state.category :', this.$store.state.category.categories);
        return this.$store.state.category.categories;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("updateCategory", val);
      },
    },
    titleInnert: {
      get() {
        return this.$store.state.app.titleInner;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setTitleInner", val);
      },
    },
    currentShop: {
      get() {
        return this.$store.state.shops.currentShop;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setCurrentShop", val);
      },
    },
    selectTab: {
      get() {
        return this.$store.state.app.selectTab;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setSelectTab", val);
      },
    },
    allPages: {
      get() {
        const vApp = this;
        let getAllPages = vApp.$store.getters.getAllPages;
        const slugPage = vApp.$route.path.slice(1);
        if(DEBUG) console.log("path slug :>> ", vApp.$route.path);
        if(DEBUG) console.log(" slugPage :>> ", slugPage);
        if(DEBUG) console.log(" getAllPages :>> ", getAllPages);
        if(DEBUG) console.log(
          "this.$store.getters.getAllPages :>> ",
          getAllPages.find((sp) => sp.slug.trim() === slugPage.trim())
        );
        return getAllPages.find((sp) => sp.slug.trim() === slugPage.trim());
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setAllPages", val);
      },
    },
  },
  methods: {
    sortArray(array, property, direction) {
      direction = direction || 1;
      array.sort(function compare(a, b) {
        let comparison = 0;
        if (a[property] > b[property]) {
          comparison = 1 * direction;
        } else if (a[property] < b[property]) {
          comparison = -1 * direction;
        }
        return comparison;
      });
      return array; // Chainable
    },
    slectShopFromAll(nShop) {
      let vApp = this;
      if(DEBUG) console.log("nShop :", nShop);
      vApp.currentShop = nShop;
      vApp.$router.push(
        "/" + vApp.loadPathData.mnuShopsPath + "/" + nShop.slug
      );
    },

    selectCategory(numCat) {
      let vApp = this;
      if(DEBUG) console.log("Select numCat :", numCat);
      if(DEBUG) console.log("vApp.categories[0].category :", vApp.categories[0]);
      if(DEBUG) console.log(
        "vApp.categories[0].category[numCat].id :",
        vApp.categories[0].category[numCat].namesubcat
      );

      let nameSubCut = vApp.categories[0].category[numCat].slug;

      vApp.$router.push(
        "/" + vApp.loadPathData.mnuShopsPath + "/category/" + nameSubCut
      );

      vApp.filterShops = null;
      vApp.selectGrpId = numCat;

      axios({
        method: "get",
        url:
          "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_all_shops/json/" +
          vApp.categories[0].category[numCat].id,
      })
        .catch(function (error) {
          if(DEBUG) console.log("ERROR: ", error);
        })
        .then(function (response) {
          if(DEBUG) console.log("response dataAll Category = ", response.data);
          vApp.filterShops = vApp.sortArray(response.data, "nameK");
          if(DEBUG) console.log("vApp.filterShops :", vApp.filterShops);
        });


      vApp.titleInnert = vApp.categories[0].category[numCat].namesubcat;
    },
    selectActions() {
      let vApp = this;
      if(DEBUG) console.log("Select numCat :", vApp.shops);

      vApp.filterShops = vApp.shops.filter((fact) => fact.actions.length > 0);
      if(DEBUG) console.log("vApp.filterShops :", vApp.filterShops);
    },
    selectFilter(numFiltr) {
      let vApp = this;
      if(DEBUG) console.log("Select numFiltr :", numFiltr);
      vApp.selectF = numFiltr;

      switch (numFiltr) {
        case 0:
          vApp.filterShops = null;
          vApp.filterShops = vApp.shops;
          break;
        case 1:
          //  vApp.filterShops = vApp.shops;
          vApp.selectCategory(0);
          break;
        case 2:
          //  vApp.filterShops = vApp.shops;
          vApp.titleInnert = "МАГАЗИНЫ";

          if (vApp.$store.state.shops.shopsAZ === null) {
            vApp.loadAZ();
            vApp.selectAZ("A");
          } else {
            vApp.shopsAZ = vApp.$store.state.shops.shopsAZ;
            vApp.alphabetArr = Object.keys(vApp.$store.state.shops.shopsAZ);
            vApp.selectAZ("A");
          }

          break;
        case 3:
          vApp.titleInnert = "МАГАЗИНЫ";
          vApp.selectActions();

          break;

        default:
          break;
      }
    },
    selectAZ(letteR) {
      let vApp = this;
      if(DEBUG) console.log("Select letteR :", letteR);
      if(DEBUG) console.log("vApp.shopsAZ :", vApp.shopsAZ);
      if (vApp.shopsAZ === null) {
      }

      vApp.selectAB = letteR;
      vApp.selectAZShops = [];
      for (const key in vApp.shopsAZ) {
        if (vApp.shopsAZ.hasOwnProperty(key)) {
          const elAZ = vApp.shopsAZ[key];

          /*  if(DEBUG) console.log('key :', key);
             if(DEBUG) console.log('elAZ :', elAZ);
            */

          if (letteR.letter === "0-9") {
            if(DEBUG) console.log("parseInt(key) :>> ", parseInt(key));
            if (parseInt(key) < 10) {
              vApp.selectAZShops.push(...elAZ);
            }
          } else {
            if (key === letteR) {
              vApp.selectAZShops = elAZ;
            }
          }
        }
      }
      if(DEBUG) console.log("vApp.selectAZShops :>> ", vApp.selectAZShops);
      let allShops = vApp.shops;

      let arrIdAZ = vApp.selectAZShops.map((azS) => azS.id);
      if(DEBUG) console.log("vApp.selectAZShops :>> ", arrIdAZ);
      let arrShopAZFilter = [];
      for (let idxAZ = 0; idxAZ < arrIdAZ.length; idxAZ++) {
        const elAZ = arrIdAZ[idxAZ];
        arrShopAZFilter.push(allShops.find((fID) => fID.id === elAZ));
      }
      if(DEBUG) console.log("arrShopAZFilter :>> ", arrShopAZFilter);
      vApp.filterShops = arrShopAZFilter;
    },
    loadAZ() {
      let vApp = this;
      axios({
        method: "get",
        url:
          "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_shops_alph_2",
        //url: "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_shops_alph"
      })
        .catch(function (error) {
          if(DEBUG) console.log("ERROR AZ: ", error);
        })
        .then(function (response) {
          if(DEBUG) console.log(
            " @@@@@@@@@@@@@@@@@   response ПО БУКВАМ = ",
            response.data
          );
          vApp.$store.dispatch("setShopsAZ", response.data);
          vApp.shopsAZ = response.data;
          vApp.alphabetArr = Object.keys(response.data);
        });
    },
  },

  mounted() {
    let vApp = this;
    if(DEBUG) console.log("selectTab :>", vApp.selectTab);
    this.$nextTick(function () {
      if(DEBUG) console.log("mounted AllShops");

      if(DEBUG) console.log("allPages :>", vApp.allPages);
      if(DEBUG) console.log("vApp.loadPathData :>", vApp.loadPathData);
      vApp.titleInnert = "МАГАЗИНЫ";
      this.$store.dispatch('fetchData')
      if (vApp.$store.state.shops.shops === null) {
        axios({
          method: "get",
          url:
            "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_all_shops/json",
        })
          .catch(function (error) {
            if(DEBUG) console.log("ERROR: ", error);
          })
          .then(function (response) {
            if(DEBUG) console.log("response dataAllShops =", response.data);
            let gAllShp = response.data;
            gAllShp = vApp.sortArray(gAllShp, "nameK");
            vApp.shops = gAllShp;
            vApp.selectFilter(vApp.selectTab);
          });
      } else {
        vApp.selectFilter(vApp.selectTab);
      }

      let scrollEl = document.querySelector("#scrollT");
      scrollEl.scrollTo(0, 0);
    });
  },
  updated: function () {
    this.$nextTick(function () {
      // Код, который будет запущен только после
      // обновления всех представлений
      if(DEBUG) console.log("RENDER UPDATE");
    });
  },
};
</script>
<style  scope>
.name-shop-img {
  line-height: 1.1;
  min-height: 36px;
}

.ramka {
  width: 90%;
  height: 90%;
}

.ab-btn {
  width: 20px;
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: rgba(255, 255, 255, 1) !important;
}
.empty-sale {
  min-height: 28px;
}
.sceleton-img {
  max-height: 160px;
}
</style>